import { OpenChatMessage } from "@/types/open-chat";

export const INITIAL_MESSAGE: OpenChatMessage = {
  id: "initial",
  content: "Welcome to open chat by pathfinder. The answers given are not document grounded.",
  type: "ai",
};
